<section class="quick-order container">
  <div class="quick-order__header">
    <h1 class="page-title">{{ 'global.quickOrder' | translate }}</h1>
  </div>
  <!-- dialog content -->
  <form class="quick-order__form" [formGroup]="orderForm">
    <div>
      <div class="quick-order__fields">
        <pwj-upload-files
          label="uploader.image"
          formControlName="file_ids"
          multiple></pwj-upload-files>

        <div class="fields-container">
          <!-- product title filed -->
          <pwj-input
            class="quick-order__input"
            icon="notes-1"
            iconPosition="left"
            [placeholder]="'home.enterYourProductTitle' | translate"
            [label]="'home.productTitle' | translate"
            formControlName="title"
            [messages]="{ required: 'requires.productTitle' }"></pwj-input>

          <!-- product category input -->
          <pwj-select-dropdown
            label="home.productCategory"
            placeholder="home.enterYourProductCategory"
            icon="grid-apps"
            iconPosition="left"
            variant="outlined"
            [options]="productCategories"
            formControlName="category_id"></pwj-select-dropdown>

          <!-- user email -->
          <pwj-input
            class="order-order__input"
            icon="mail"
            iconPosition="left"
            [placeholder]="'home.enterYourEmail' | translate"
            [label]="'global.email' | translate"
            formControlName="email"
            type="email"></pwj-input>

          <!-- description input -->
          <pwj-input
            icon="stickynote"
            iconPosition="left"
            [isTextAreaMode]="true"
            placeholder="global.description"
            label="global.description"
            rows="5"
            formControlName="description"
            [messages]="{ required: 'requires.description' }">
          </pwj-input>
        </div>
      </div>

      <!-- submit button -->
      @if (isUserLoggedIn) {
        <div class="quick-order__footer">
          <pwj-button
            class="submit-btn"
            [ngClass]="{
              '!pointer-events-none !cursor-not-allowed': formIsSubmitting,
            }"
            variant="primary"
            size="medium"
            icon="chevron-right"
            [rotateIconInRtl]="true"
            [iconReversePosition]="true"
            type="submit"
            (click)="!formIsSubmitting && submitOrder()"
            [disabled]="
              orderForm.invalid || isDisabledSubmitBtn || formIsSubmitting
            "
            >{{ 'global.send' | translate }}</pwj-button
          >
        </div>
      } @else {
        <div>
          <pwj-register-button title="global.send"></pwj-register-button>
        </div>
      }
    </div>
  </form>
</section>
